import { graphql } from "react-relay";
import { EventSummaryExternalAttendees } from "./EventSummaryExternalAttendees";

export const eventSummaryExternalAttendeesFragments = {
  org: graphql`
    fragment EventSummaryExternalAttendees_org on Org {
      id
      domains
    }
  `,
  attendees: graphql`
    fragment EventSummaryExternalAttendees_attendees on Attendee @relay(plural: true) {
      displayName
      urnValue
      profileId
      urnType
    }
  `,
};
